// @ts-check
import React, { StatelessComponent } from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

/** @type { StatelessComponent<{title: string, extraTitleContent: JSX.Element}> } */
const PageHeader = ({ title, extraTitleContent }) => (
  <div id="content-header" data-spec-id="page-component-title">
    <h1>
      {title} {!!extraTitleContent ? extraTitleContent : null}
    </h1>
  </div>
);

PageHeader.propTypes = {
  title: PropTypes.string,
  extraTitleContent: PropTypes.node,
};

function mapStateToProps({ pageData }, ownProps) {
  return {
    title: pageData.title || ownProps.title,
  };
}

export default connect(mapStateToProps)(PageHeader);
